export default "__VITE_PUBLIC_ASSET__b8979b87__"